export enum UserOperationType {
    ADD = "add",
    EDIT = "edit",
}

